import { fetchRequest } from 'src/hooks/useAPIRequest'
import { API_ENDPOINTS } from 'src/routes/routes'

interface Params {
    username: string
    password: string
    token: string
}

const resetPassword = async (params: Params) => {
    return await fetchRequest(API_ENDPOINTS.RESET_PASSWORD, { method: 'POST', data: JSON.stringify(params) })
}

export default resetPassword
